import React from 'react'
import { withTheme } from 'styled-components'

const ActiveBar = ({ theme }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="116"
      viewBox="0 0 9 116"
    >
      <g>
        <g>
          <path
            fill={theme.colors.buttonDefault}
            d="M0 9.487C0 4.408 3.986.26 9 0v115.99c-5.014-.26-9-4.408-9-9.487z"
          />
        </g>
      </g>
    </svg>
  )
}

export default withTheme(ActiveBar)
